import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteLlmProfile } from '@/lib/api/generated/api';

import { toLlmProfileError } from '../errors';
import { llmProfileKeys } from '../queryKeys';

/**
 * Delete an LLM profile outright.
 *
 * Refused with `LlmProfileInUseError` while any workflow step still
 * references it, or `LlmProfileDefaultForModelError` while it is the
 * default for its model and other profiles for that model exist (FR-015a).
 */
export function useDeleteLlmProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (slug: string): Promise<void> => {
      const response = await deleteLlmProfile(slug);
      if (response.status === 204) return;
      throw toLlmProfileError(response.status, response.data);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: llmProfileKeys.all() });
    },
  });
}
